export default __webpack_public_path__ + "static/media/home-gray.5eda5a44.svg";